export default "__VITE_ASSET__CefhSuMj__"